import { createSelector } from 'reselect';

const selectGlobalDbnTaxonomyDomains = (state: any) => state.globalDbnTaxonomyDomains;


export const selectGlobalDbnTaxonomyDomainsCurrentItem = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.current);

export const selectGlobalDbnTaxonomyDomainsListItems = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDbnTaxonomyDomainsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDbnTaxonomyDomainsQueryItems = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.query);

export const selectGlobalDbnTaxonomyDomainsCreatedItem = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.create);

export const selectGlobalDbnTaxonomyDomainsPublishedItem = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.publish);

export const selectGlobalDbnTaxonomyDomainsUpdatedItem = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.update);

export const selectGlobalDbnTaxonomyDomainsReadItem = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.read);

export const selectGlobalDbnTaxonomyDomainsDeletedItem = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.delete);

export const selectGlobalDbnTaxonomyDomainsSearchedItems = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.search);

export const selectGlobalDbnTaxonomyDomainsItemsCount = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.count);

export const selectGlobalDbnTaxonomyDomainsItemsFilter = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.filter);

export const selectGlobalDbnTaxonomyDomainAccountMappingsListItems = createSelector([selectGlobalDbnTaxonomyDomains], (globalDbnTaxonomyDomains) => globalDbnTaxonomyDomains.accountMappingslist);
